import classNames from 'classnames';
import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import { getProductUspsConfig } from './helpers';
import BenefitItem from './BenefitItem';
import UspsModal from './UspsModal';

const Usps = ({ className }: { className?: string }) => {
  const {
    additionalInfo,
    selectedOffer,
    selectedSkuDetails: { condition, freeReturnDays, categoryName },
  } = useProductPageContext();

  const [isOpen, setIsOpen] = useState(false);

  const { items, displayWarranty } = getProductUspsConfig({
    additionalInfo,
    condition,
    freeReturnDays,
    categoryName,
    vendorCountry: selectedOffer?.location?.country,
  });

  return (
    <div className="w-full" datatest-id="benefits-panel">
      <button
        type="button"
        className={classNames(
          'group relative flex h-full w-full items-center justify-between rounded-md px-3 py-3 text-left focus:outline-none lg:px-2 lg:py-0 lg:pl-0',
          className,
        )}
        onClick={() => setIsOpen(true)}
      >
        <div className="space-y-2 lg:space-y-1">
          {items.map((item) => (
            <BenefitItem key={item.id} item={item} />
          ))}
        </div>
        <ChevronRight className="h-5 w-5 transition-transform duration-150 group-hover:translate-x-0.5" />
      </button>
      <UspsModal
        warranty={displayWarranty}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        freeReturnDays={freeReturnDays}
      />
    </div>
  );
};

export default Usps;
